import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export const dollarCurrencyMask = (value: number, withDecimals?: boolean) => {
  const { country } = getCurrentlySelectedLocation();
  const currencySymbol = country === 'United Kingdom' ? '£' : '$';
  return `${currencySymbol}${value.toFixed(withDecimals ? 2 : 0)}`;
};
